import { render } from "./WhitelabelPrimaryLogo.vue?vue&type=template&id=42aa4e5e&ts=true"
import script from "./WhitelabelPrimaryLogo.vue?vue&type=script&lang=ts"
export * from "./WhitelabelPrimaryLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__